module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-right-white-tall-ee5646ad982e198077efa222905c2666.svg";